export default "__VITE_ASSET__CXhjLRxp__"